export interface Program {
  id: string
  name: string
  description: string
  image: string
}

export const programs: Program[] = [
  {
    id: 'kids-martial-arts',
    name: 'Kids Martial Arts',
    description:
      'Structured martial arts training for children that builds discipline, confidence, and physical skills through age-appropriate instruction and progressive curriculum.',
    image:
      'https://cdn.magicpatterns.com/uploads/rpUYVX6BTHcZD8MvBJVyvv/kids.jpg',
  },
  {
    id: 'teen-adult-classes',
    name: 'Teen & Adult Classes',
    description:
      'Comprehensive martial arts training for teens and adults focused on self-defense, fitness, and personal development through disciplined practice and skill progression.',
    image:
      'https://cdn.magicpatterns.com/uploads/34YrwX6Uh42ERRoswozkZD/Teen-and-Adults.jpg',
  },
  {
    id: 'brazilian-jiu-jitsu',
    name: 'Brazilian Jiu-Jitsu',
    description:
      'Ground-based grappling martial art that develops technical skill, strategic thinking, and physical conditioning through systematic training and live practice.',
    image:
      'https://cdn.magicpatterns.com/uploads/aPhpJAWqY3QBXFC8MurJd8/bjj.jpg',
  },
  {
    id: 'competition-team',
    name: 'Competition Team',
    description:
      'Advanced training program for dedicated students pursuing competitive excellence in martial arts tournaments and demonstrations.',
    image:
      'https://cdn.magicpatterns.com/uploads/dKu77WG1JfW9jNjCFoWbEn/competition.jpg',
  },
]

export function getProgramById(id: string): Program | undefined {
  return programs.find((program) => program.id === id)
}
